module.exports = __webpack_public_path__ + "static/media/newTeam.13075eaa.jpeg";